import { render, staticRenderFns } from "./EnvironmentTemplate.vue?vue&type=template&id=1c34edbe"
import script from "./EnvironmentTemplate.vue?vue&type=script&lang=js"
export * from "./EnvironmentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports